import { pushTrackerEvent } from '../../_googleTagManager';

export default function datalayerTracking() {
  function hasDataAttribute(element, prefix) {
    for (let i = 0; i < element.attributes.length; i++) {
      if (element.attributes[i].name.indexOf(prefix) === 0) {
        return true;
      }
    }
    return false;
  }

  let linkDlAttribute = document.querySelectorAll('a');
  let getTargetLocation = function (href) {
    let l = document.createElement('a');
    l.href = href;
    return l;
  };

  if (linkDlAttribute) {
    for(let item of linkDlAttribute) {
      item.addEventListener('click', function() {
        let tracking_future = null;

        let dataDlAttribute = hasDataAttribute(item, 'data-dl-');
        let dataJsonAttribute = item.getAttribute('data-dl-json');

        if (dataDlAttribute === true && dataJsonAttribute === null) {
          let eventData = {}

          Array.from(item.attributes).forEach(function (attr) {
            if (attr.specified && attr.name.indexOf('data-dl-') === 0) {
              if (attr.name !== 'data-dl-json') {
                let getName = attr.name.replace('data-dl-', '');
                let getValue = attr.value;

                switch (getName) {
                  case 'tracking_feature':
                    tracking_future = attr.value.replace(/_/g, '.');
                    break;
                  case 'target_url':
                    getValue = item.href;
                    break;
                  case 'target_path':
                    getValue = getTargetLocation(item.href).pathname + getTargetLocation(item.href).search + getTargetLocation(item.href).hash;
                    break;
                  case 'event_path':
                    getValue = location.pathname;
                    break;
                }

                eventData[getName] = getValue;
              }
            }
          });

          pushTrackerEvent(tracking_future, eventData, '');
        }

        if (dataJsonAttribute) {
          try {
            const correctedJson = dataJsonAttribute.replace(/'/g, '"');
            const jsonData = JSON.parse(correctedJson);

            jsonData.forEach(entry => {
              let eventData = {}

              for (const key in entry) {
                if (entry.hasOwnProperty(key) && typeof entry[key] === 'object') {
                  tracking_future = key;

                  for (const innerKey in entry[key]) {
                    if (entry[key].hasOwnProperty(innerKey)) {
                      switch (innerKey) {
                        case 'target_path':
                          eventData[innerKey] = getTargetLocation(item.href).pathname + getTargetLocation(item.href).search + getTargetLocation(item.href).hash;
                          break;
                        case 'event_path':
                          eventData[innerKey] = location.pathname;
                          break;
                        default:
                          eventData[innerKey] = entry[key][innerKey];
                      }
                    }
                  }
                }
                pushTrackerEvent(tracking_future, eventData, '');
              }
            });
          } catch (error) {
            console.error('Fehler beim Parsen des JSON:', error);
          }
        }
      })
    }
  }
}
